
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { startLogout } from '../../actions/auth'

export const UserMenu = () => {

  const {name, cart } = useSelector( state => state.auth)

    const dispatch = useDispatch()
   

    const handleLogout = () => {
        
        dispatch(   startLogout() )
      
    }
  return (
 
                 
        <div className="">
            <div 
              className="dropdown" 
              type="button" 
              id="dropdownMenuButton1" 
              data-bs-toggle="dropdown" 
              aria-expanded="false"
            >
             {cart && cart.length >=1 && 
            <i className="fa-solid fa-cart-shopping">  { " " +cart.length}</i>
          }
                {name}
            </div>

                <ul className="dropdown-menu"   aria-labelledby="dropdownMenuButton1">
                    <li>  <Link to="/perfil" className='nav-menu-items'> Mi Perfil </Link></li> 
                    <li>  <Link to="/cart" className='nav-menu-items'> Carrito </Link></li> 
                    <li onClick={handleLogout} className='nav-menu-items'>Cerrar Session</li>       
                </ul>
        </div>

   
  )
}
